<script setup lang="ts">
import { faEyes } from '@fortawesome/duotone-regular-svg-icons'
import { useAppColor } from '~/composables/useAppColor'
import Button from '~/components/ui/Button.vue'
import AuPopover from '~/components/ui/AuPopover.vue'

defineProps<{
  collapsed: boolean
}>()

const { themeColor } = useAppColor()
</script>

<template>
  <AuPopover
    v-if="collapsed"
    side="bottom"
    align="start"
  >
    <template #trigger>
      <Button variant="outline" :color="themeColor">
        <font-awesome-icon :icon="faEyes" />
        {{ $t('sources.showSources') }}
      </Button>
    </template>

    <template #content>
      <div class="prose prose-au w-[60ch] p-6">
        <h2>
          {{ $t('sources.sources') }}
        </h2>
        <slot />
      </div>
    </template>
  </AuPopover>

  <div
    v-else
    class="au-color-box not-prose flex gap-6 rounded-xl border-2 border-(--theme-10,#fff3) p-6"
  >
    <div class="au-prose w-full self-center">
      <h2 class="cms-h cms-h2 flex items-center">
        {{ $t('sources.sources') }}
      </h2>
      <slot />
    </div>

    <div class="ml-auto grid flex-none text-lg">
      <font-awesome-icon
        size="2x"
        :icon="faEyes"
        :style="{
          '--fa-primary-color': 'var(--theme-60,black)',
          '--fa-secondary-color': 'var(--theme-10,#fffa)',
          '--fa-secondary-opacity': '1',
        }"
      />
    </div>
  </div>
</template>
